import React from 'react';
import {Box, styled} from '@mui/material';
import translate from '@/utils/translate';
import LEGACY_COLORS from '@/styles/legacyColors';

const StyledContainer = styled(Box)(() => ({
  textAlign: 'center',
}));

const StyledText = styled('div')(() => ({
  fontSize: '16px',
  lineHeight: '25px',
  fontWeight: '400',
  color: LEGACY_COLORS.GRAY,
  margin: 0,
}));

const StyledFAQLink = styled('a')(() => ({
  textDecoration: 'underline',
  color: LEGACY_COLORS.GRAY,
}));

/**
 * SupportSection - A component that displays support text with a link to FAQs
 * for users having trouble linking their social accounts
 */
function SupportSection() {
  return (
    <StyledContainer>
      <StyledText>
        {translate('Having trouble linking your account?')}
      </StyledText>
      <StyledText>
        {translate('Check our FAQs for help')}{' '}
        <StyledFAQLink
          href="https://help-popularpays.lightricks.com/hc/en-us/categories/24969753771282-Creator-Experience"
          target="_blank"
          rel="noopener noreferrer"
        >
          {translate('here.')}
        </StyledFAQLink>
      </StyledText>
    </StyledContainer>
  );
}

export default SupportSection;
